export enum PressJoinCategory {
	/**
	 * Einpressgewindemutter
	 */
	SelfClinchingNuts,

	/**
	 * Einpressgewindebolzen
	 */
	SelfClinchingThreadedStud,

	/**
	 * Einpressgewindebuchse
	 */
	SelfClinchingThreadedStandoff,
}
